export default (document) => {
  function getFileUrl(serverUrl) {
    return new URL(document.file_url, serverUrl);
  }

  return {
    ...document,
    fileWithServerUrl: getFileUrl(process.env.VUE_APP_DIGOF_URL),
  };
};
